import './LineItemsTableHeader.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

const [block, element] = bem('line-items-table-header');

const LineItemsTableHeader = (): React.JSX.Element => {
  return (
    <thead className={block()}>
      <tr>
        <th className={element('expand')} />
        <th className={element('placement-id')}>Placement Id</th>
        <th className={element('placement-name')}>Placement Name</th>
        <th className={element('ad-type')}>Ad Type</th>
        <th className={element('name')}>Ad Name</th>
        <th className={element('creative')}>Creative</th>
        <th className={element('date')}>Start Date</th>
        <th className={element('date')}>End Date</th>
        <th className={element('settings')} />
      </tr>
    </thead>
  );
};

export default LineItemsTableHeader;
